import {MaterialSymbol, SymbolCodepoints} from "react-material-symbols";
import {Chip as MuiChip} from "@mui/material";
import {BORDER_RADIUS_OUTER} from "../themes/theme";
import {RichText, RichTextViewModel, getString} from "./RichText";

export type ChipViewModel = {
  label: RichTextViewModel;
  icon?: SymbolCodepoints;
  style?: {
    backgroundColor?: string;
    color?: string;
    fontSize?: string;
    fontWeight?: number;
  };
};

export function Chip(props: ChipViewModel) {
  return (
    <MuiChip
      label={<RichText {...props.label} />}
      icon={
        props.icon ? (
          <MaterialSymbol
            icon={props.icon}
            color="inherit"
            size={16}
            style={{marginLeft: "6px", marginRight: "-6px"}}
            fill
          />
        ) : undefined
      }
      sx={{
        height: "24px",
        color: props?.style?.color ?? "inherit",
        backgroundColor: props?.style?.backgroundColor,
        borderRadius: BORDER_RADIUS_OUTER,
        fontSize: props?.style?.fontSize ?? "0.75rem",
        fontWeight: props?.style?.fontWeight ?? 400,
        "& .MuiChip-label": {px: 1.25},
      }}
    />
  );
}
